import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  GitData,
  GitVersion,
  GlobalSessionData,
  GlobalFunctions
} from 'globales-projekt-angular';
import { environment } from 'src/environments/environment';
import { ConstantsTexte } from './immutable/constants-texte';
import { ApiService } from './services/api.service';
import * as gitVersion from '../git-version.json';
import * as globalGitVersion from '../global-git-version.json';
import { LocalService } from './services/local.service';
import { SpinnerService } from './components/elemente/mat-spinner-overlay/service/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  showWaitingForDataSpinner: boolean = false;

  constructor(
    private apiService: ApiService,
    private spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private localService: LocalService
  ) {
    GlobalSessionData.baseUrl = environment.baseUrl;
    this.localService.appComponentRef.next(this);
  }

  ngOnInit() {
    this.spinnerService.spinnerCount$.subscribe((count: number) => {
      this.showWaitingForDataSpinner = count > 0;
      this.cdr.detectChanges();
    });

    this.apiService.getGitData().subscribe((response: GitData) => {
      GlobalFunctions.printGitData(
        response,
        new GitVersion(gitVersion),
        new GitVersion(globalGitVersion),
        ConstantsTexte.ANWENDUNGSNAME,
        !environment.production
      );
    });

  }
}
